import { csrfToken } from 'rails-ujs';

$(() => {
  $('.input-skill-level').on('change', function() {
    var skill_id = $(this).attr('name');
    var level = $(this).val();

    $.ajax({
      type: 'PUT',
      url: '/api/user_skill',
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: {
        'skill_id': skill_id,
        'level': level
      },
    });
  });
});
